import React, { createContext, useState, useEffect, ReactNode } from "react";
import { axiosInstance } from "../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../utils/constants";


interface SidebarContextType {
	sidebarData: any[];
	isLoading: boolean;
	isSidebarOpen: boolean;
	toggleSidebar: () => void;
}

export const SidebarContext = createContext<SidebarContextType>({
	sidebarData: [],
	isLoading: false,
	isSidebarOpen: false,
	toggleSidebar: () => {
		// eslint-disable-next-line @typescript-eslint/no-empty-function
	},
});

interface ImagesProviderProps {
	children: ReactNode;
}

export const SidebarMenuProvider: React.FC<ImagesProviderProps> = ({ children }) => {
	const [sidebarData, setSidebarData] = useState<any>([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);


	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	const getSidebarMenu = async () => {
		try {
			const response = await axiosInstance.get(API_ENDPOINTS.MenuList);			
			setSidebarData(response.data.result.items);
		} catch (error) {
			console.error("Error fetching images:", error);
		}
	};

	useEffect(() => {
		getSidebarMenu();
	}, []);

	return (
		<SidebarContext.Provider value={{ sidebarData, isLoading, isSidebarOpen, toggleSidebar }}>
			{children}
		</SidebarContext.Provider>
	);
};
